[{"name":"España (Península)","value":"ES"},{"name":"Islas Canarias","value":"IC"},{"name":"France","value":"FR"},{"name":"United Kingdom","value":"GB"}]